import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchLeaderboardPeriods, type LeaderboardPeriodsData } from '@/lib/network';

const STALE_TIME_MS = 10 * 60 * 1000;
const GC_TIME_MS = 30 * 60 * 1000;

/**
 * The leaderboard period list (gameweeks/matchdays) for a tournament calendar.
 * Shared by every leaderboard surface so the `['leaderboard-periods', tcId]`
 * query is defined once; React Query dedupes the network call across consumers.
 * Disabled (and resolves to `null`) until a tournament calendar id is known.
 */
export const useLeaderboardPeriods = (
  tournamentCalendarId: string | null,
  includeAll: boolean = false
): UseQueryResult<LeaderboardPeriodsData | null, Error> =>
  useQuery({
    queryKey: ['leaderboard-periods', tournamentCalendarId, includeAll],
    queryFn: async () => {
      if (!tournamentCalendarId) {
        return null;
      }
      const res = await fetchLeaderboardPeriods(tournamentCalendarId, includeAll);
      return res.data;
    },
    enabled: !!tournamentCalendarId,
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
  });
